import React from 'react';
import './styles.css';
import SearchIcon from '@mui/icons-material/Search';

const SearchBar = ({ value, changeInput }) => (
  <div className='searchBar-wrap'>
      <input className="input-small"
             type='text'
             placeholder='Write smth to search...'
             value={value}
             onChange={changeInput}
      />
    <SearchIcon className='searchBar-icon' />

  </div>
);

export default SearchBar;
